module.exports = __webpack_public_path__ + "static/media/nodejs-original-wordmark.f13b681b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodejs-original-wordmark.svg
// module id = 99
// module chunks = 0